import { render, staticRenderFns } from "./CustomerSummaryComponent.vue?vue&type=template&id=0c42540c&"
import script from "./CustomerSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports